// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cc-2";
export var aiChatCartContainerExit = "_cc-4";
export var aiChatContainerLarge = "_cc-0";
export var aiChatContainerSmall = "_cc-1";
export var aiChatIcon = "_cc-6";
export var slideInFromRight = "_cc-3";
export var slideOutToRight = "_cc-5";